const DRAFT_KEY = "billing_quote_resume_draft_v1";
const PENDING_KEY = "billing_quote_resume_pending";

export function saveQuoteResumeDraft(requestId, shopId, draft, requestDisplayType = null) {
  if (!requestId || !draft) return;
  sessionStorage.setItem(
    DRAFT_KEY,
    JSON.stringify({
      requestId: Number(requestId),
      shopId: shopId ? Number(shopId) : null,
      requestDisplayType,
      draft,
      savedAt: Date.now(),
    }),
  );
  sessionStorage.setItem(PENDING_KEY, "1");
}

export function loadQuoteResumeDraft() {
  try {
    const raw = sessionStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearQuoteResumeDraft() {
  sessionStorage.removeItem(DRAFT_KEY);
  sessionStorage.removeItem(PENDING_KEY);
}

export function hasQuoteResumePending() {
  return sessionStorage.getItem(PENDING_KEY) === "1";
}

export function buildDashboardBillingReturnPath(shopId, requestId) {
  const params = new URLSearchParams();
  if (shopId) params.set("shopId", String(shopId));
  if (requestId) params.set("resumeQuote", String(requestId));
  const qs = params.toString();
  return qs ? `/mechanic-dashboard?${qs}` : "/mechanic-dashboard";
}

export function parseResumeQuoteRequestId(searchParams) {
  const raw =
    typeof searchParams?.get === "function"
      ? searchParams.get("resumeQuote")
      : new URLSearchParams(String(searchParams || "")).get("resumeQuote");
  if (!raw) return null;
  const id = parseInt(raw, 10);
  return Number.isNaN(id) ? null : id;
}
